import { type FC, type ReactNode, type MouseEvent, type RefObject } from 'react'

import styles from './Sidebar.module.scss'

interface SidebarItemProps {
    icon: ReactNode
    text: string
    onClick: (e: MouseEvent<HTMLButtonElement>) => void
    isDisabled?: boolean
    children?: ReactNode
    buttonRef?: RefObject<HTMLButtonElement>
}

const SidebarItem: FC<SidebarItemProps> = ({
    icon,
    text,
    onClick,
    children,
    isDisabled,
    buttonRef
}) => {
    return (
        <button
            ref={buttonRef}
            type="button"
            className={styles.item}
            onClick={onClick}
            disabled={isDisabled}
        >
            <div className={styles.icon}>{icon}</div>
            <div className={styles.label}>{text}</div>
            {children}
        </button>
    )
}

export default SidebarItem